import React from "react";
import { Card, Text } from "rebass";

interface IProps {
  email: string;
}

export function SuccessMessage({ email }: IProps) {
  return (
    <Text as="p" color="#2b3160">
      <span>We send reset password link to your email. Please check</span>

      &nbsp;

      <Card
        as="span"
        px="4px"
        borderRadius="4px"
        backgroundColor="sp-blue-50"
      >
        {email}
      </Card>
    </Text>
  )
}
